import * as React from "react";

const CheckIcon = ({ width = "15px", height = "15px" }) => (
  <svg width={width} height={height} fill="none" viewBox="0 0 20 20">
    <rect
      x={0.5}
      y={0.5}
      width={19}
      height={19}
      rx={2.5}
      fill="var(--theme-background)"
      stroke="var(--theme-background)"
    />
    <path
      d="M4.888 8.713 3 10.755 8.522 16l8.66-11.282L15.002 3l-6.8 8.86-3.314-3.147Z"
      fill="#fff"
    />
  </svg>
);

export default CheckIcon;
